module.exports = __webpack_public_path__ + "static/img/shws.bf6c3099.png";